import { Injectable, signal } from '@angular/core';

import type { Member } from '../types';

@Injectable({ providedIn: 'root' })
export class MemberCacheService {
  private readonly member = signal<Member | null>(null);

  set(member: Member): void {
    this.member.set(member);
  }

  snapshot(): Member {
    const m = this.member();

    if (!m) throw new Error('Member not loaded');

    return m;
  }
}
